var render = function render(){var _vm=this,_c=_vm._self._c;return ((_vm.exercisesInfo.answerVo&&_vm.exercisesInfo.answerVo.mComments))?_c('div',{staticStyle:{"margin-top":"10px"}},[_c('el-card',{attrs:{"shadow":"always"}},[_c('div',[_c('p',{staticClass:"analysis"},[_c('span'),_c('span',[_vm._v("教师批语")])]),_c('p',[_vm._v(" "+_vm._s(_vm.exercisesInfo.answerVo.mComments)+" ")])])])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }